import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=1b15b8ce&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b15b8ce')) {
      api.createRecord('1b15b8ce', component.options)
    } else {
      api.reload('1b15b8ce', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=1b15b8ce&", function () {
      api.rerender('1b15b8ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25xx73rc6ZHze/JS/comp/openstreetmap.vue"
export default component.exports